import React, { useState, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";
import InviteMemberModal from "./InviteMemberModal";
import EditUserModal from "./EditUserModal";
import ProtectedButton from "../RBAC/ProtectedButton";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ApiHelper } from "../../utils/ApiHelper";
import { USERS_DATA } from "../../lib/API_KEYS";
import Pagination from "../Common/Pagination";
import SearchBar from "../Common/SearchBar";

const UserTable = ({subRoles}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        console.log("Fetching users...");
        const response = await new ApiHelper().FetchFromServer(...USERS_DATA, {
          ...(search && { search }),
          page: currentPage,
          limit: perPage,
        });

        const results = response.data?.results || [];
        setUsers(results);
        setTotalResults(response.data?.totalResults || results.length);
        setTotalPages(response.data?.totalPages || 1);
      } catch (err) {
        console.error("Error fetching users:", err);
        setUsers([]);
        setTotalResults(0);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [search, currentPage, perPage]);


  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditUserModalOpen(true);
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-menu") && !event.target.closest(".btn-sm")) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownClick = (idx) => {
    setOpenDropdown(openDropdown === idx ? null : idx);
  };

  return (
    <>
      <div className="container mt-4 border rounded p-3">
        <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
          <h4 className="fw-bold">Users Management</h4>
          <ProtectedButton
            permission="createUser"
            className="btn text-white"
            style={{ minWidth: "120px", backgroundColor: "#181D4C", border: "none" }}
            onClick={() => setIsModalOpen(true)}
          >
            + Add Member
          </ProtectedButton>
          <InviteMemberModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            subRoles= {subRoles}
          />
        </div>

        <p className="text-muted mb-2">
          View, manage, and organize user access and roles with ease and efficiency
        </p>

        <div className="container mt-4 border rounded p-3">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <h5 className="fw-bold">Users</h5>
            <SearchBar
              search={search}
              setSearch={setSearch}
              setCurrentPage={setCurrentPage}
            />
          </div>



          <div className="table-responsive">
            <table className="table table-hover border p-0 align-middle">
              <thead style={{ backgroundColor: "#FCFCFC" }}>
                <tr>
                  <th className="text-muted border">Member</th>
                  <th className="text-muted border">Role</th>
                  <th className="text-muted border">Country</th>
                  <th className="text-muted border">City</th>
                  <th className="text-muted border">Postal Code</th>
                  <th className="text-muted border">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={3} className="text-center py-3">
                      Loading team members...
                    </td>
                  </tr>
                ) : users.length > 0 ? (users.map((user, idx) => (
                  <tr key={user.id}>
                    <td className="border">
                      <div className="d-flex align-items-center">
                        {user.profilePic ? (
                          <img
                            src={user.profilePic}
                            alt={user.name}
                            className="rounded-circle me-2"
                            width="40"
                            height="40"
                          />
                        ) : (
                          <div
                            className="rounded-circle me-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#181D4C",
                              color: "#fff",
                              fontWeight: "600",
                              fontSize: "18px",
                            }}
                          >
                            {user.name.charAt(0).toUpperCase()}
                          </div>
                        )}
                        <div>
                          <strong>{user.name}</strong>
                          <br />
                          <small>{user.email}</small>
                        </div>
                      </div>
                    </td>

                    <td className="border">
                      <span className="badge text-dark" style={{ backgroundColor: "#F1F1F4" }}>{user.role}</span>
                    </td>
                    <td className="border">{user.country}</td>
                    <td className="border">{user.city}</td>
                    <td className="border">{user.postcode}</td>
                    {/* <td className="border">
                          {Array.from({ length: 5 }, (_, i) => (
                            <span
                              key={i}
                              style={{
                                cursor: "pointer",
                                color: i < user.rating ? "#ffc107" : "#e4e5e9",
                                fontSize: "18px",
                              }}
                              onClick={() => updateRating(user.id, i + 1)}
                            >★</span>
                          ))}
                        </td> */}
                    <td className="text-end position-relative">
                      <button className="btn btn-sm" onClick={() => handleDropdownClick(idx)}>
                        <FiMoreVertical />
                      </button>
                      {openDropdown === idx && (
                        <div className="dropdown-menu show" style={{ position: "absolute", right: 0, top: "50%", zIndex: 1000 }}>
                          <ProtectedButton
                            permission="updateUser"
                            className="dropdown-item d-flex align-items-center gap-2"
                            onClick={() => handleEditClick(user)}
                          >
                            <img src="/images/edit.svg" alt="edit" style={{ width: "16px", height: "16px" }} />
                            Edit
                          </ProtectedButton>
                          {/* <ProtectedButton
                            permission="deleteUser"
                            className="dropdown-item text-danger d-flex align-items-center gap-2"
                          >
                            <img src="/images/delete.svg" alt="delete" style={{ width: "16px", height: "16px" }} />
                            Delete
                          </ProtectedButton> */}
                        </div>
                      )}
                    </td>
                  </tr>
                ))) : (
                  <tr>
                    <td colSpan={3} className="text-center text-muted py-3">
                      No team members found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            perPage={perPage}
            setPerPage={setPerPage}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            totalPages={totalPages}
            totalResults={totalResults}
          />
        </div>
      </div>

      <EditUserModal
        isOpen={editUserModalOpen}
        onClose={() => setEditUserModalOpen(false)}
        user={selectedUser}
        onSave={(updatedUser) => {
          setUsers(users.map((u) => (u._id === updatedUser._id ? updatedUser : u)));
        }}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </>

  );
};

export default UserTable;
